import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<Actions.SELECT_VIP_PRO_ASYNC, Actions.SELECT_VIP_PRO_SUCCESS, Actions.SELECT_VIP_PRO_FAIL>,
): State => {
  switch (action.type) {
    case Actions.SELECT_VIP_PRO_ASYNC:
    case Actions.SELECT_VIP_PRO_SUCCESS:
    case Actions.SELECT_VIP_PRO_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
